import { isNilOrEmptyString } from 'ramda-extension';

import { REQUEST_SIZE } from 'constants/general';
import { cleanse, toIsoDateFormat } from 'utils';

import { productionStatuses } from '../common/constants';

export const queryParamsFactory = (sort) => {
	return {
		sort,
		page: 0,
		size: REQUEST_SIZE,
	};
};

export const requestBodyFactory = (formData, userRole) => {
	return cleanse({
		productionStatusIds: [productionStatuses.VALID],
		orgStruct: {
			channelId: formData.channel,
			regionId: formData.region,
			agencyIds: [formData.agency],
			manager: formData.manager,
			seller: formData.seller,
			ppz: formData.ppz,
		},
		policyNo: formData.policyNumber,
		scanned: isNilOrEmptyString(formData.scan) ? undefined : Boolean(formData.scan),
		reportedDateFrom: toIsoDateFormat(formData.reportDateFrom),
		reportedDateTo: toIsoDateFormat(formData.reportDateTo),
		userRole,
		withoutPpz: !formData.withoutPpz,
		documentTypeId: formData.documentType,
	});
};
